export default __webpack_public_path__ + "ad881f2e19f0cfefeb8bc38e0406227d.png";